/**
 * Presentational modal frame for RMA action flows: title, description, free-form body, and fixed footer buttons.
 */
import { DefaultModalLayout } from "../../../../../components/modal/layouts/default-modal-layout";
import FontBody1 from "../../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR } from "../../../../../components/fonts/font-props";
import "./rma-action-modal.scss";
import { FormField } from "../../../../../components/form-field/form-field";
import { BUTTON_VARIANTS } from "../../../../../components/inputs/button-variants";
import { Button } from "../../../../../components/inputs/button/button";
import { Input } from "../../../../../components/inputs/input/input";
import type { ReactNode } from "react";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import { IRmaActionBase } from "../../stores/rma-page-store";


export interface IRmaActionModalLayoutProps {
	rmaAction: IRmaActionBase;
    children: ReactNode;
    onDismiss: () => void;
    onSubmit: () => void;
    isLoading?: boolean;
    isDisabled?: boolean;
}

const RmaActionModalLayout: React.FC<IRmaActionModalLayoutProps> = ({
	rmaAction,
    children,
    onDismiss,
    onSubmit,
    isLoading,
    isDisabled,
}) => {

	const {getTranslation} = useDashboardTranslation();
	const scope = "dashboard-returns-rma-card";

	const title = rmaAction.modalTitleTranslationKey
		? getTranslation(rmaAction.modalTitleTranslationKey, scope)
		: getTranslation(rmaAction.name, scope);

	const description = getTranslation(rmaAction.descriptionTranslationKey, scope);
	const submitLabel = getTranslation(rmaAction.buttonTextTranslationKey, scope);
	const dismissLabel = getTranslation("KEEP_CURRENT_STATUS", scope);

	return (
		<DefaultModalLayout isCloseDisabled={true} onCloseClicked={() => {}}>
			<div className={"action-modal-content"}>
				<FontBody1 color={FONT_COLOR.NEUTRAL3}>{title}</FontBody1>
				<FontBody1 color={FONT_COLOR.PRIMARY3}>{description}</FontBody1>
				{children}
				<div className="action-modal-buttons">
					<Button
						text={dismissLabel}
						onClick={onDismiss}
						variant={BUTTON_VARIANTS.Tertiary}
						disabled={isLoading || isDisabled}
					/>
					<Button
						text={submitLabel}
						onClick={onSubmit}
						variant={BUTTON_VARIANTS.Primary}
						isLoading={isLoading || isDisabled}
						hasLoader={true}
					/>
				</div>
			</div>
		</DefaultModalLayout>
	);
}

export default RmaActionModalLayout;
